import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/brands`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/brands`, body, config);
};

export const Put = (payload, config = {}) => {
  const id = payload.id;
  return APIService.put(`/v01/brands/${id}`, {
    ...payload,
  }, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/brands/${id}`, config);
};

export const All = () => {
  return APIService.get(`/v01/active-brands`);
};

const BrandService = {
  List,
  Create,
  Put,
  Delt,
  All
};
export default BrandService;
